import { render } from "./ErrorPage.vue?vue&type=template&id=52dceab2&scoped=true"
const script = {}

import "./ErrorPage.vue?vue&type=style&index=0&id=52dceab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dceab2"]])

export default __exports__